<template>
  <form
    id="contact-form"
    class="mt-5"
    data-scroll-trigger="true"
    @submit.prevent="handleSubmit"
  >
    <div
      class="row contact-form_container"
      data-scroll-animation="y, autoAlpha"
      data-stagger=""
    >
      <div class="block-input">
        <input
          ref="emailInput"
          type="email"
          placeholder="Enter your email"
          v-model="email"
          @input="validateForm"
          :class="{
            'form-control': true,
            'consultation-form-input': true,
            error: isEmailInputInvalid,
          }"
        />
        <div class="box_input contact-form__box_input">
          <div class="select-container">
            <GetCountriesCode
              v-model="code"
              :isCodeInputInvalid="isCodeInputInvalid"
              @input="updateFormValidation"
            />
            <!-- <select
              class="form-control box_input_code"
              v-model="code"
              @change="updateFormValidation"
              :class="{ error: isCodeInputInvalid }"
            ></select> -->
          </div>
          <input
            ref="phoneInput"
            type="tel"
            class="form-control box_input_phone"
            placeholder="Enter your phone"
            v-model="phone"
            @input="updateFormValidation"
            :class="{ error: isPhoneInputInvalid }"
          />
        </div>
        <div>
          <textarea
            type="textarea"
            class="form-control"
            placeholder="Enter your message"
            v-model="message"
          ></textarea>
        </div>
      </div>
      <div class="col-12 py-2 mt-3">
        <button class="btn btn-primary w-100" type="submit">Send</button>
      </div>
    </div>
  </form>
</template>

<script>
import { DataService } from "../../../config/dataService";
import InputCustom from "../InputCustom.vue";
import GetCountriesCode from "./../GetCountriesCode.vue";

export default {
  name: "ContactForm",
  components: {
    InputCustom,
    GetCountriesCode,
  },
  data() {
    return {
      email: "",
      phone: "",
      code: "",
      message: "",
      isEmailInputInvalid: false,
      isPhoneInputInvalid: false,
      isCodeInputInvalid: false,
    };
  },
  methods: {
    handleSubmit() {
      const variantForm = {
        form: "contact-form",
      };

      if (this.validateForm()) {
        const formData = {
          email: this.email.toLowerCase(),
          phone: this.phone,
          code: this.code,
          userMessage: this.message,
        };
        DataService.post("send-email", { variantForm, formData })
          .then((res) => {
            this.$notifications.notify({
              message: `<span>Message sent successfully</span>`,
              icon: "nc-icon nc-email-83",
              horizontalAlign: "right",
              verticalAlign: "top",
              type: "success",
            });
          })
          .catch((error) => {
            console.log(error);
          });
      }
    },
    validateForm() {
      this.isEmailInputInvalid = false;
      this.isPhoneInputInvalid = false;
      this.isCodeInputInvalid = false;

      let isValid = true;

      if (!this.email.trim() && !this.phone.trim() && !this.code) {
        // Коли поля відсутні
        this.isEmailInputInvalid = true;
        this.isPhoneInputInvalid = true;
        this.isCodeInputInvalid = true;
        isValid = false;
      } else if (!this.email.trim() && !this.phone.trim() && this.code) {
        // Коли тільки вибраний код
        this.isPhoneInputInvalid = true;
      } else if (this.email.trim() && !this.phone.trim() && !this.code) {
        // Коли тільки емейл
        if (!this.validateEmail()) {
          isValid = false;
        }
      } else if (this.phone.trim() && !this.email.trim() && this.code) {
        // Коли тільки телефон
        if (!this.validatePhone()) {
          isValid = false;
        }
      }

      return isValid;
    },

    validateEmail() {
      const emailRegex =
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

      if (emailRegex.test(this.email.trim())) {
        this.isEmailInputInvalid = false;
        return true;
      } else {
        this.isEmailInputInvalid = true;
        return false;
      }
    },
    validatePhone() {
      // Валідація номеру телефона
      return true;
    },
    updateFormValidation() {
      if (this.code) {
        this.isEmailInputInvalid = false;
        this.isPhoneInputInvalid = !this.phone.trim();
      } else {
        this.isPhoneInputInvalid = false;
        this.isEmailInputInvalid = !this.email.trim();
      }
      this.isCodeInputInvalid = false;
    },
  },
};
</script>

<style scoped lang="scss"></style>
